module.exports = __webpack_public_path__ + "static/media/footrest.5fa72c78.svg";